<template>
  <v-simple-table dense class="border">
    <thead>
      <tr>
        <th class="text-left">Producto</th>
        <th class="text-right" style="width: 90px">Cotizado</th>
        <th class="text-right" style="width: 100px">Distribuido</th>
        <th class="text-right" style="width: 90px">Emitido</th>
        <th v-if="showPrice" class="text-right" style="width: 120px">Precio neto</th>
        <th class="text-left">Estado</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="!products || !products.length">
        <td :colspan="showPrice ? 6 : 5" class="caption grey--text text-center">La cotización no tiene productos</td>
      </tr>
      <tr v-for="p in products" :key="p.key">
        <td class="caption text-left"><span class="grey--text">#{{ p.key }}</span> {{ p.name }}</td>
        <td class="text-right caption">{{ fmt(p.quoted) }}</td>
        <td class="text-right caption font-weight-bold" :class="{ 'warning--text': p.warning }">{{ fmt(p.distributed) }}</td>
        <td class="text-right caption">{{ fmt(p.emitted) }}</td>
        <td v-if="showPrice" class="text-right caption">{{ price(p.unit_price) }}</td>
        <td class="caption text-left">
          <span v-if="p.warning" class="warning--text"><v-icon x-small color="warning" class="mr-1">fas fa-triangle-exclamation</v-icon>{{ p.warning }}</span>
          <span v-else-if="p.info" class="grey--text">{{ p.info }}</span>
          <span v-else class="success--text"><v-icon x-small color="success" class="mr-1">fas fa-check</v-icon>Distribuido completo</span>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  name: 'DistributionProductSummary',
  props: {
    products: { type: Array, default: () => [] },
    showPrice: { type: Boolean, default: false },
  },
  methods: {
    price(n) {
      if (n === null || n === undefined) return '—'
      return '$' + Number(n).toLocaleString('es-CL', { maximumFractionDigits: 2 })
    },
    fmt(n) {
      const v = Number(n || 0)
      return Number.isInteger(v) ? v.toLocaleString('es-CL') : v.toLocaleString('es-CL', { maximumFractionDigits: 2 })
    },
  },
}
</script>
